import { Component, Input, OnInit } from '@angular/core';
import {
  HeroDispositionResponseDto,
  IDisplayData
} from '@whetstoneeducation/hero-common';
import { FormGroup } from '@angular/forms';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'app-hero-disposition-edit',
  templateUrl: './hero-disposition-edit.component.html',
  styleUrls: ['./hero-disposition-edit.component.scss']
})
export class HeroDispositionEditComponent implements OnInit {
  @Input() heroDisposition: HeroDispositionResponseDto;
  @Input() form: FormGroup;
  @Input() behaviorCodeOptions: IDisplayData[];
  @Input() behaviorCodeReactionOptions: IDisplayData[];

  public filteredBehaviorCodeOptions: Observable<IDisplayData[]>;
  public filteredBehaviorReactionOptions: Observable<IDisplayData[]>;

  constructor() { }

  ngOnInit() {
    this.filteredBehaviorCodeOptions = this.form.get('behaviorCodeId').valueChanges.pipe(
      startWith(''),
      map((value) => {
        const label = typeof value === 'string' ? value : value?.display;
        return this._filter(label, 'behaviorCodeOptions');
      })
    );

    this.filteredBehaviorReactionOptions = this.form.get('behaviorCodeReactionId').valueChanges.pipe(
      startWith(''),
      map((value) => {
        const label = typeof value === 'string' ? value : value?.display;
        return this._filter(label, 'behaviorCodeReactionOptions');
      })
    );
  }

  private _filter(value: string, options: string): IDisplayData[] {
    if (!this[options]) {
      return [];
    } else if (!value) {
      return this[options];
    }

    const filterValue = value?.toLowerCase();

    return this[options].filter((option) => option.display.toLowerCase().includes(filterValue));
  }

  displaySelectedOption(options: string, optionSelected: number) {
    const groupSelected = this[options].find(item => item.value === optionSelected);
    return groupSelected?.display || '';
  }

  public onClear(control: string) {
    this.form.get(control).setValue(undefined);
  }
}
